import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import HighchartsVue from 'highcharts-vue'
import VueHtmlToPaper from 'vue-html-to-paper';
import moment from "moment";
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.use(HighchartsVue)
Vue.use(VueHtmlToPaper);
Vue.use(moment.locale("es"))

moment.locale("es");

Vue.config.productionTip = false

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

const API = 'https://espacio-natural.tedesco.es/api/'

let back = window.location.host == 'localhost:8080' ? API : API;

axios.defaults.baseURL=back

new Vue({
  router,
  store,
  vuetify,
  created () {
    AOS.init()
  },
  render: h => h(App)
}).$mount('#app')
